import React from "react"
import { Link } from "gatsby"
import { useInView } from "react-intersection-observer"

import Layout from "../../components/layout"
import Header from "../../components/header"
import Projects from "../../components/projects"

const ArtCenter = () => {
  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0,
  })

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  return (
    <Layout>
      <Header />
      <div className="project">
        <div className="container-fluid subheader">
          <div className="row">
            <div className="col-lg-4">
              <h2>04. ArtCenter Library</h2>
            </div>
            <div className="offset-lg-1 col-lg-3">
              <h2>2020</h2>
            </div>
            <div className="col-lg-4">
              <h2>Identity, Exhibition</h2>
            </div>
          </div>
        </div>
        <div className="container-fluid p-0">
          <div className="row no-gutters">
            <div className="col-12 hero hero-artcenter">
              <div className={`hero-footer ${inView}`}>
                <div className="row justify-content-between align-items-end">
                  <div className="col-lg-5 d-none d-md-block">
                    <h2>
                      <Link to="/projects/sueños">Previous Project(03) ↖</Link>
                    </h2>
                    <h2>
                      <Link to="/projects/pueblo-sonidero">
                        Next Project(05) ↗
                      </Link>
                    </h2>
                  </div>
                  <div className="col-md-3 d-none d-md-block">
                    <h2>
                      <Link to="/">rg-rq.com</Link>
                    </h2>
                  </div>
                  <div className="offset-md-2 col-md-2">
                    <button onClick={scrollTop}>
                      <h2>
                        Back up
                        {inView ? (
                          <img
                            className="img-fluid"
                            src="/Up.svg"
                            alt="cheveron icon"
                          />
                        ) : (
                          <img
                            className="img-fluid"
                            src="/Up-white.svg"
                            alt="cheveron icon"
                          />
                        )}
                      </h2>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid content">
          <div className="row text-section">
            <div className="col-lg-5">
              <p>ArtCenter Library </p>
            </div>
            <div className="col-lg-7">
              <p>
                Many of the forms are inspired by objects from within and around
                the library space, which include the architecture of ArtCenter,
                books, book spines, library shelves, and other environmental
                forms that help not only create but also inform, complete, and
                define the feeling of this space as a whole.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/02_al0vxe.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/03_twmvsa.jpg"
                alt=""
              />
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/04_f8bftq.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/05_mpkcgo.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/06_j1gaky.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/07_zwjufp.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/08_gixpjn.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/09_vazpql.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/10_criixx.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/11_dygzif.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/12_ggbizc.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/13_athzuk.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <div className="embed-responsive embed-responsive-1by1">
                <video
                  className="embed-responsive-item"
                  autoPlay
                  loop
                  muted
                  playsInline
                >
                  <source
                    src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/static/artcenter/14_ty0gii.mp4"
                    type="video/mp4"
                  />
                </video>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/15_so6s0e.jpg"
                alt=""
              />
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/16_u5yhon.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/17_rtwtx9.jpg"
                alt=""
              />
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/18_ef1unt.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/19_ppguj0.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/20_jwf5be.jpg"
                alt=""
              />
            </div>
            <div className="col-8 m-d-60">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/21_wd4fko.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/22_hq1etp.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/23_mthbod.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/24_qmonig.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/25_niunb2.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/26_a5zyyp.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/27_u7nnhp.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/28_m15kv4.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/29_i34uqa.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/30_af274h.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/31_zksk7t.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/32_cxjou0.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/33_swtsbs.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/34_vbxwrm.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/35_rf6h3i.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-8 m-d-60">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/36_vcbngr.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/37_kxvqiw.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/38_gdkgo8.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/39_uwlbqo.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/40_iowjmm.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/41_qyikv5.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/42_hwibnx.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/43_shbzec.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/44_vaetga.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/45_enwvw5.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/46_avw6dt.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/47_patr26.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/48_sascxh.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/49_kno2qn.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/50_ujfkgo.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/51_skvgrk.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/52_kizoak.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/53_j7iffz.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/54_egqfoc.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/55_i5goyl.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/56_iph3t2.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/57_pdsrqh.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/58_dr3zdh.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/59_kksncp.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/60_suel6d.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/61_hnehro.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/62_amhlqy.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/63_mio8bg.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/64_iv53rf.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/65_fygb0u.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/66_uz91ch.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/67_a6t9mq.jpg" 
                alt=""
              />
            </div>
            <div className="col-12 col-md-8">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/68_tienme.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/69_sjpewl.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/70_e6frwb.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/71_ngovrz.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/72_gjudwr.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/73_rqmrei.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/74_cosqv0.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/75_hvlwbh.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/76_tgoji1.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/77_g4ha3c.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/78_i95ykf.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/79_neljmk.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/80_cebrkn.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/81_livd7n.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/82_orylhi.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/83_j0ugwl.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/84_gxennw.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/85_ghnz0s.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-4">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/86_fiy30m.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/87_jrorfa.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/88_yuls1h.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/89_jppufy.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/90_uafslg.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/91_ge9opj.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/92_pbtbva.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/93_jktcky.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/94_sdyk9j.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/95_qxpbw8.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/96_ifbebq.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/97_wqr8uv.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/artcenter/98_uwj4np.jpg"
                alt=""
              />
            </div>
          </div>
          <div className="row text-section">
            <div className="col-lg-5">
              <p>Credits</p>
            </div>
            <div className="col-lg-7">
              <p>01.–24. Photography by Maribel Barcena Lopez</p>
            </div>
          </div>
          <div className="row text-section">
            <div className="col-lg-5">
              <p>Special Thank You</p>
            </div>
            <div className="col-lg-7">
              <p>Rolando Castillo</p>
              <p>Maria Trakovsky</p>
              <p>Ozzy Alvarez</p>
              <p>Jennifer Faist </p>
              <p>Alfonso Huerta </p>
              <p>Robert Lundquist</p>
              <p>Mario Ascencio</p>
              <p>Rachel Julius</p>
              <p>Joseph Abernethy</p>
              <p>Gabriel Pulgar</p>
              <p>Ramon Munoz</p>
            </div>
          </div>
        </div>
      </div>
      <div ref={ref}></div>
      <Projects />
    </Layout>
  )
}
export default ArtCenter
